import { GuestDetails, RsvpDetails, StepsTranslationsStrings } from "../../models/api/rsvpApiTypes"
import { CORE_STEP_NAMES, TranslationsStringsType } from "../../models/enum/rsvpEnum"
import useStepNavigation from "../../hook/useStepNavigation"
import inputErrorMessage from "../../json/inputErrorMessage.json"
import TextInput from "../Inputs/TextInput"

interface StepEmailProps {
  buttonColor?: string
  backButtonColor?: string
  strings?: StepsTranslationsStrings[]
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  setStep: (name: string) => void
  stepPipeline: string[]
  languge: string
}

export default function StepEmail({
  buttonColor,
  backButtonColor,
  strings,
  rsvp,
  setStep,
  stepPipeline,
  setRsvp,
  languge,
}: StepEmailProps) {
  const { goNext, goPrevious } = useStepNavigation(stepPipeline, CORE_STEP_NAMES.EMAIL, setStep)

  const inputErrorMessageString =
    inputErrorMessage.translations.find((x) => x.lang === languge) === undefined
      ? inputErrorMessage.translations[0]
      : inputErrorMessage.translations.find((x) => x.lang === languge)

  const setEmail = (email: string, guest: GuestDetails) => {
    const newGuests = rsvp.invitation.guests.map((g) => {
      if (g.id === guest.id) {
        g = {
          ...guest,
          rsvp: {
            accepted: g.rsvp.accepted,
            arrivalDate: g.rsvp.arrivalDate,
            email: email.length > 0 ? email : null,
            intolerances: g.rsvp.intolerances,
            busTransferNeeded: g.rsvp.busTransferNeeded,
          },
        }
      }
      return g
    })
    setRsvp({ ...rsvp, invitation: { ...rsvp.invitation, guests: newGuests } })
  }

  return (
    <>
      {rsvp.invitation.guests.map((guest) => (
        <div key={guest.id} style={{ marginTop: "5px" }}>
          {guest.rsvp.accepted && guest.rsvpSettings.showEmail && (
            <>
              <label className="box-form-label">
                {guest.name} {guest.surname}
              </label>
              <TextInput
                className="box-form-input"
                type="email"
                placeholder={strings?.find((x) => x.type === TranslationsStringsType.PLACEHOLDER)?.value}
                value={guest.rsvp.email}
                onChange={(value) => setEmail(value ?? "", guest)}
              />
              {guest.rsvp.email !== null && guest.rsvp.email?.length > 0 && !/\S+@\S+\.\S+/.test(guest.rsvp.email) ? (
                <div className="box-form-input-error">{inputErrorMessageString?.inputEmailNotValid}</div>
              ) : null}
            </>
          )}
        </div>
      ))}

      <div style={{ display: "flex", flexDirection: "row" }}>
        <button
          style={{ backgroundColor: backButtonColor, borderColor: backButtonColor }}
          type="button"
          className="btn btn-primary box-button-left"
          onClick={goPrevious}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.LEFTBUTTON)?.value}
        </button>
        <button
          type="button"
          className="btn btn-primary box-button-right"
          style={{ backgroundColor: buttonColor, borderColor: buttonColor }}
          onClick={goNext}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.MAINBUTTON)?.value}
        </button>
      </div>
    </>
  )
}
